let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cUSsQ")).then(() => parcelRequire('lCM2t'));